import { IApplicationState } from '../../types/redux';

export function getMedia(state: IApplicationState) {
  const {
    newbuilding: { media },
  } = state;

  return media && media.length ? media : null;
}
